// @flow

import React from 'react';
import CustomEvent from 'custom-event';

const Subscribe = (): React.Element<any> =>
  (<div
    id="subscribe-to-podcast"
    className="site-lightbox__modal site-lightbox__modal--subscribe centered center center--both"
  >
    <h3 className="h4 theme--dark-blue">Subscribe to Podcast</h3>
    <ul className="list icon-grid links links--aqua">
      <li className="list__item icon-grid__item">
        <a
          href="https://itunes.apple.com/us/podcast/ferguson-voices-trailer/id1257831451?i=1000389729252"
          target="_blank"
          rel="noopener noreferrer"
          className="svg-wrapper icon"
        >
          <svg
            role="img"
            aria-labelledby="site-lightbox-subscribe-apple"
            focusable="false"
          >
            <title id="site-lightbox-subscribe-apple">
              Subscribe on Apple iTunes
            </title>
            <use xlinkHref="#icon-apple" />
          </svg>
        </a>
      </li>
      <li className="list__item icon-grid__item">
        <a
          href="https://play.google.com/music/listen?u=0#/ps/I7gv755ttio36ve23famdgfpz6y"
          target="_blank"
          rel="noopener noreferrer"
          className="svg-wrapper icon"
        >
          <svg
            role="img"
            aria-labelledby="site-lightbox-subscribe-google-play"
            focusable="false"
          >
            <title id="site-lightbox-subscribe-google-play">
              Subscribe on Google Play
            </title>
            <use xlinkHref="#icon-google-play" />
          </svg>
        </a>
      </li>
      <li className="list__item icon-grid__item">
        <a
          href="https://soundcloud.com/fergusonvoicespod"
          target="_blank"
          rel="noopener noreferrer"
          className="svg-wrapper icon"
        >
          <svg
            role="img"
            aria-labelledby="site-lightbox-subscribe-soundcloud"
            focusable="false"
          >
            <title id="site-lightbox-subscribe-soundcloud">
              Subscribe on Soundcloud
            </title>
            <use xlinkHref="#icon-soundcloud" />
          </svg>
        </a>
      </li>
      <li className="list__item icon-grid__item">
        <a
          href="https://www.stitcher.com/podcast/moral-courage-project/ferguson-voices-disrupting-the-frame"
          target="_blank"
          rel="noopener noreferrer"
          className="svg-wrapper icon"
        >
          <svg
            role="img"
            aria-labelledby="site-lightbox-subscribe-stitcher"
            focusable="false"
          >
            <title id="site-lightbox-subscribe-stitcher">
              Subscribe on Stitcher
            </title>
            <use xlinkHref="#icon-stitcher" />
          </svg>
        </a>
      </li>
      <li className="list__item icon-grid__item">
        <a
          href="https://beta.tunein.com/radio/Ferguson-Voices-Disrupting-the-Frame-p1011474/"
          target="_blank"
          rel="noopener noreferrer"
          className="svg-wrapper icon"
        >
          <svg
            role="img"
            aria-labelledby="site-lightbox-subscribe-tunein"
            focusable="false"
          >
            <title id="site-lightbox-subscribe-tunein">
              Subscribe on TuneIn
            </title>
            <use xlinkHref="#icon-tunein" />
          </svg>
        </a>
      </li>
      <li className="list__item icon-grid__item">
        <a
          href="http://feeds.soundcloud.com/users/soundcloud:users:261304047/sounds.rss"
          target="_blank"
          rel="noopener noreferrer"
          className="svg-wrapper icon"
        >
          <svg
            role="img"
            aria-labelledby="site-lightbox-subscribe-rss"
            focusable="false"
          >
            <title id="site-lightbox-subscribe-rss">Subscribe via RSS</title>
            <use xlinkHref="#icon-rss" />
          </svg>
        </a>
      </li>
    </ul>
    <div className="links links--aqua">
      <button
        className="btn btn--default btn--icon-left"
        onClick={() => {
          global.dispatchEvent(new CustomEvent('closeModal'));
        }}
      >
        <svg aria-hidden="true" className="icon--small" focusable="false">
          <use xlinkHref="#icon-close-circled" />
        </svg>
        <span>Close</span>
      </button>
    </div>
  </div>);

export default Subscribe;



// WEBPACK FOOTER //
// ./screens/App/components/Subscribe/index.js